import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";
import { MdOutlineFileUpload } from "react-icons/md";
import { MdSync } from "react-icons/md"; // Add this import for the sync icon
import redirectURL from "../../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import dsStorescsv from "../../../assets/json/warehouses.csv";
import "./warehouses.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const darkStoreColumnDefs = [
  { headerName: "SKU", field: "sku" },
  { headerName: "PRODUCTS", field: "products" },
  { headerName: "For", field: "for" },
  { headerName: "Batch No", field: "batch_no" },
  { headerName: "Actual Batch no.", field: "actual_batch_no" },
  { headerName: "M DATE", field: "m_date" },
  { headerName: "E DATE", field: "e_date" },
  { headerName: "Total Shelf Life", field: "total_shelf_life" },
  { headerName: "Day Completed", field: "day_completed" },
  { headerName: "Day Left", field: "day_left" },
  { headerName: "O.BALANCE", field: "obalance" },
  { headerName: "BAD BIN", field: "bad_bin" },
  { headerName: "RECEIPT", field: "receipt" },
  { headerName: "Inward", field: "inward" },
  { headerName: "DISPATCHES", field: "dispatches" },
  { headerName: "QC Hold QC Reusable", field: "qc_hold_qc__reusable" },
  { headerName: "CLS. BAL", field: "cls_bal" },
  { headerName: "File Name", field: "filename", hide: true },
];

const WarehousesTab = () => {
  const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

  const [currentDate, setCurrentDate] = useState(today);
  const [selectedStore, setSelectedStore] = useState({ label: "Gurgaon WH", value: "D005", warehouse: "Gurgaon" });
  const [filteredData, setFilteredData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertType, setAlertType] = useState("info");
  const [isLoading, setIsLoading] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [availableDates, setAvailableDates] = useState([]);
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState(new Date())
  const [prevDate, setPrevDate] = useState([])
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([])
  const [currentUploadedDate, setCurrentUploadedDate] = useState("");
  const [show, setShow] = useState(false);
  const [basicType, setBasicType] = useState("");
  const [basicTitle, setBasicTitle] = useState("");
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [file, setFile] = useState(null)
  const [selectedDs, setSelectedDs] = useState(null)
  const [darkStoreData, setDarkStoreData] = useState([])
  const [filename, setFilename] = useState("")
  const [darkStores, setDarkStores] = useState([])
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [highlightedDates, setHighlightedDates] = useState([])
  const [warehouseColumnDefs, setwarehouseColumnDefs] = useState(darkStoreColumnDefs)
  const [fetchedIds, setFetchedIds] = useState([]) // Add this state
  const [status, setStatus] = useState(""); // Add this state for fetch status
  const gridColumnApi = useRef(null);
  const gridApi = useRef(null);
  
  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  const getDarkStoreData = async () => {
    var params = {};
    if (selectedStore && selectedStore.value){
      params.warehouse_id = selectedStore.value
    }
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/getWarhousesData",
        params
      );
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.data.status === "success") {
        setCurrentInvoiceDate(response.data.date)
        setDarkStoreData(response.data.data)
      } else {
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to getting data";
      console.log({ errorMessage })
    }
  }

  const getWarehouseFiltersData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/getWarehouseFiltersData", {}
      );

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.status === 200) {
        var {warehouseData, dates, fetched_warehouse_ids} = response.data // Add fetched_warehouse_ids from response
        warehouseData = warehouseData.map((item) => ({ label: item.destination_store_name, value: item.destination_store_id , warehouse : item.destination_store_name.split(" ")[0] }));
        dates = dates.map((d) => new Date(d))
        console.log("warehouseData", warehouseData);
console.log("fetched_warehouse_ids", fetched_warehouse_ids);
console.log("length", (fetched_warehouse_ids || []).length);
        setDarkStores(warehouseData)
        setHighlightedDates(dates)
        setFetchedIds(fetched_warehouse_ids || []) // Set fetched IDs
        
        // Set status based on the conditions
        if ((fetched_warehouse_ids || []).length === 0) {
          setStatus("warning"); // No stores fetched
          
        } else if ((fetched_warehouse_ids || []).length === warehouseData.length) {
          setStatus("successAllFetched"); // All stores fetched
        } else {
          setStatus("successPartialFetched"); // Some stores fetched
        }
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to getting Warehouse Filters";
      console.log({ errorMessage })
    }
  }

  useEffect(() => {
    const getMainData = async () => {
      await getWarehouseFiltersData()
      await getDarkStoreData()
    }
    getMainData()
  }, []);

  const handleApplyFilter = async () => {
    if (!selectedStore || !currentinvoiceDate) {
      alert("Please select both DS and Date to filter.");
      return;
    }

    const params = {
      date: currentinvoiceDate,
      store: selectedStore?.value || ""
    };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post(
        "inventory/getWarhousesDataByDateAndWarehouse",
        params
      );

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      const resData = response.data;

      if (resData.status === "success") {
        setDarkStoreData(resData.data);
        setCurrentInvoiceDate(resData.date);
      } else if (resData.status === "info") {
        setShow(true);
        setBasicType("info");
        setBasicTitle(resData.message || "No data found for the selected filters.");
        setDarkStoreData([]);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to fetch data.";
      setShow(true);
      setBasicType("error");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Upload Warehouse Data");
    setOverlyBlock("show-m");
  };

  // Add this function for fetching warehouse data
  const onClickFetchData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Fetch Warehouse Data");
    setSelectedDs(null)
    setOverlyBlock("show-m");
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
  };

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const handleDataUpload = async (upload_type) => {
    const params = { 
      date: currentDate, 
      dark_store_id: selectedDs?.value || "",
      dark_store_name: selectedDs?.label || "", 
      warehouse: selectedDs?.warehouse || "", 
      masterData: uploadedFileData, 
      filename ,
      upload_type
    };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/storeWarehouseData",
        params
      );

      if (response.data.status === "success") {
        await getDarkStoreData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Uploaded Successfully");

        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded Warehouses Data",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Data Upload Failed");

        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded Warehouses Data",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to upload data";
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Uploaded Warehouses Data",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
    }
  }

  // Add this function for fetching warehouse data from API
  const handleFetchData = async () => {
    if (!currentDate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select Date to fetch data.");
      return;
    }

    const params = {
      trigger_date: currentDate
    };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post(
        "inventory/fetchWarehouseStockData", 
        params
      );

      const res = response?.data?.pyResponse;

      if (res.status == "Success"){
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(res.message);
        await getWarehouseFiltersData(); // Refresh the filters data
        await getDarkStoreData(); // Refresh the warehouse data

        // User action audit
        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Fetched Warehouse Data",
          status: res.status,
          path: window.location.pathname
        });
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(res.message);
        await getWarehouseFiltersData();
        await getDarkStoreData();
      }

    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      setShow(true);
      setBasicType("error");
      setBasicTitle(
        error?.response?.data?.message || "Failed to fetch warehouse data."
      );

      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Fetched Warehouse Data",
        status: "Error",
        path: window.location.pathname
      });
    }
  };

  const checkDataWithDateAndDarkStore = async () => {
    try {
      const response = await redirectURL.post(
        "inventory/checkWarehouseDataByDateAndStore",
        {
          date: currentDate,
          store: selectedDs?.value || ""
        }
      );
      
      return response?.data?.status === "success"
        ? response.data.exists
        : false;

    } catch (err) {
      console.error("Error checking data:", err);
      return false;
    }
  };

  const checkTriggerStatus = async () => {
    try {
      const response = await redirectURL.post("inventory/checkIsTriggerDone", { trigger_date: currentDate });
      return response?.data?.status === "success"
        ? response.data.exists
        : false;

    } catch (err) {
      console.error("Error checking data:", err);
      return false;
    }
  }

  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }
    
    const firstWord = selectedDs?.label?.split(" ")[0]?.toLowerCase();
    const containsWord = filename.toLowerCase().includes(firstWord)
    if (!containsWord) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file with the correct name that matches the Warehouse name.");
      return
    }
    
    const isTriggered = await checkTriggerStatus();

    if (isTriggered) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("To Re Upload File, Kindly Revoke Trigger Inventory");
      return;
    }

    const data_exists = await checkDataWithDateAndDarkStore();

    if (data_exists) {
      setConfirmPopup(data_exists);
      return;
    }

    handleDataUpload("new_upload");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value);
    const filename = file.name;
    setFilename(filename);

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      if (!workbook.SheetNames.includes("Summary")) {
        throw new Error(`Invalid file. Expected sheet "Summary", found: ${workbook.SheetNames.join(", ")}`);
      }

      let worksheet = workbook.Sheets["Summary"];
      
      let headers = [];
      let result = [];

      if (worksheet) {
        const allRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false });

        if (allRows.length < 2) {
          console.error("Summary sheet has insufficient rows.");
          return;
        }

        const upperHeaders = allRows[0];
        const lowerHeaders = allRows[1];

        headers = lowerHeaders.map((lower, idx) => {
          const upper = upperHeaders[idx]?.toString().trim().toLowerCase() || "";
          const lowerVal = lower?.toString().trim().toLowerCase() || "";

          const isFixedLabel = /cls\.?\s*bal/i.test(lowerVal);

          let combined = "";
          if (isFixedLabel) {
            combined = lowerVal;
          } else if (lowerVal && upper) {
            combined = `${lowerVal}_${upper}`;
          } else if (lowerVal) {
            combined = lowerVal;
          } else if (upper) {
            combined = upper;
          }

          return combined
            .replace(/\s+/g, "_")
            .replace(/[A-Z]/g, (letter) => letter.toLowerCase())
            .replace(/[^a-z0-9_\-]/g, "");
        });

        result = allRows.slice(2).map(row => {
          const obj = {};
          headers.forEach((header, idx) => {
            obj[header] = row[idx] ?? "";
          });
          return obj;
        });
      }

      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };

    reader.readAsArrayBuffer(file);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("")
    setUploadedFileData([]);
  };

  const downloadExcelTemplate = async () => {
    try {
      const response = await fetch(dsStorescsv);
      const csvText = await response.text();
      const rows = csvText
        .trim()
        .split("\n")
        .map(line => line.split(","));

      const ws = utils.aoa_to_sheet(rows);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Sheet1");

      writeFile(wb, "sample_warehouse_template.xlsx");
    } catch (error) {
      console.error("Error downloading or parsing CSV:", error);
    }
  };

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {
      fileInput.value = "";
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false)
    setCurrentUploadedDate("")
  };

  // Add this function to render fetch status
  const renderStatus = () => {
    const labelMap = darkStores.reduce((acc, store) => {
      acc[store.value] = store.label;
      return acc;
    }, {});

    const fetchedLabels = fetchedIds.map(id => labelMap[id] || id);

    switch (status) {
      case "loading":
        return (
          <div style={statusStyles.loading}>
            <p>Status: LOADING</p>
          </div>
        );
      case "warning":
        return (
          <div style={statusStyles.warning}>
            <p>Status: WARNING</p>
            <p><b>No Warehouse is Fetched Yet:</b></p>
          </div>
        );
      case "successAllFetched":
        return (
          <div style={statusStyles.success}>
            <p>Status: SUCCESS</p>
            <p><b>All Warehouses Fetched:</b> No more warehouses are left to fetch.</p>
          </div>
        );
      case "successPartialFetched":
        return (
          <div style={statusStyles.success}>
            <p>Status: SUCCESS</p>
            <p><b>Fetched Warehouses:</b> {fetchedLabels.join(", ")}</p>
          </div>
        );
      case "error":
        return (
          <div style={statusStyles.error}>
            <p>Status: ERROR</p>
            <p>Failed to fetch Warehouses</p>
          </div>
        );
      default:
        return null;
    }
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  return (
    <div className="container-fluid mt-3">
      <div style={{ zIndex: "9999999" }}>
        <SweetAlert
          show={show}
          type={basicType}
          title={basicTitle}
          onConfirm={closeAlert}
          style={{ fontSize: "9px" }}
        >
        </SweetAlert>
      </div>

      <div className="row mt-3">
        <form
          className="col-sm-12 p-0 mt-4 mb-4"
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: "20px",
            justifyContent: "space-between"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px", flex: "1" }}>
            <div>
              <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                Select Warehouse:
              </label>
              <Select
                id="storeId"
                options={darkStores}
                value={selectedStore}
                onChange={(option) => setSelectedStore(option)}
                placeholder="Choose DS"
                styles={selectStyles}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column"  }}>
              <label style={{ fontSize: "13px", fontWeight: "400" }}>Uploaded Date:</label>
              <DatePicker
                selected={new Date(currentinvoiceDate)}
                onChange={(date) => {
                  setPrevDate(new Date(currentinvoiceDate));
                  setCurrentInvoiceDate(date);
                }}
                dateFormat="yyyy-MM-dd"
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                wrapperClassName="w-full"
                highlightDates={[
                  {
                    "react-datepicker__day--highlighted-custom": highlightedDates,
                  },
                ]}
              />
            </div>
            
            <div style={{ display: "flex", gap: "10px", marginTop: '30px' }}>
              <button
                type="button"
                onClick={(e) => { e.preventDefault(); handleApplyFilter(); }}
                style={{
                  height: "40px",
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "7px 20px",
                  border: "none",
                  cursor: "pointer",
                  marginTop: "1px"
                }}
              >Apply</button>

              <button
                onClick={(e) => { e.preventDefault(); getDarkStoreData(); }}
                type="button"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #d9d9d9",
                  cursor: "pointer"
                }}
              >Reset</button>

              {/* Add Fetch Warehouse Data Button */}
              <button
                onClick={(e) => { e.preventDefault(); onClickFetchData(); }}
                className="add-button upload-add-button fetch-stn"
                style={{
                  backgroundColor: "#fff",
                  color: "#93385D",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #93385D",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                <MdSync style={{ color: "#93385D", fontSize: "18px" }} />
                <span style={{ marginLeft: "6px" }}>Fetch Warehouse Data</span>
              </button>
            </div>

            {/* <button
              onClick={(e) => { e.preventDefault(); onClickUploadSkuMasterData(); }}
              type="button"
              style={{
                backgroundColor: "#fff",
                marginTop: '30px',
                color: "#93385D",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "1px solid #93385D",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}
            >
              <MdOutlineFileUpload style={{ fontSize: "18px" }} />
              Upload Warehouse Data
            </button> */}
          </div>

          <div style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "16px 24px",
            border: "1px solid #e3b7ce",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            minWidth: "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "12px"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#93385D" }}>Total SKUs</span>
              <span style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#93385D",
                backgroundColor: "#fbeff4",
                borderRadius: "6px",
                padding: "4px 12px",
                minWidth: "50px",
                textAlign: "center"
              }}>
                {darkStoreData?.length || 0}
              </span>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#93385D" }}>Closing Balance</span>
              <span style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#93385D",
                backgroundColor: "#fbeff4",
                borderRadius: "6px",
                padding: "4px 12px",
                minWidth: "60px",
                textAlign: "center"
              }}>
                {
                  darkStoreData?.reduce?.((sum, row) => {
                    const balKey = Object.keys(row || {}).find(
                      k => k.toLowerCase() === "cls_bal" || k.toLowerCase() === "cls_bal"
                    );
                    const val = balKey ? Number(row[balKey]) : 0;
                    return sum + (isNaN(val) ? 0 : val);
                  }, 0) || 0
                }
              </span>
            </div>
          </div>
        </form>
      </div>

      <div className="ag-theme-alpine " style={{ height: 500, width: "100%" }}>
        <AgGridReact
          rowData={darkStoreData}
          columnDefs={warehouseColumnDefs}
          defaultColDef={{ resizable: true, sortable: true, filter: true }}
          domLayout="normal"
          suppressHorizontalScroll={false}
          sideBar={sideBar}
          statusBar={statusPanel}
          pagination={true}
          paginationPageSize={10000}
          enableRangeSelection={true}
          onGridReady={onGridReady}
          gridOptions={{
            suppressHorizontalScroll: false
          }}
        />
      </div>
      
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => { e.preventDefault(); onClickingFileSubmit() }}
            >
              <div className="d-flex justify-content-end mb-10p">
                <div>
                  <button id="sample-download-button" className onClick={downloadExcelTemplate}>
                    Download Sample Template (.xlsx)
                  </button>
                </div>
              </div>
              <div className="mt-2">
                <label htmlFor="store" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Select Warehouse:
                </label>
                <Select
                  id="store"
                  options={darkStores}
                  value={selectedDs}
                  onChange={(option) => setSelectedDs(option)}
                  placeholder="Choose Warehouse"
                  styles={selectStyles}
                />
              </div>
              <div className="mb-1 mt-4" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>Date:</label>
                <input
                  id="uploadDate"
                  value={currentDate}
                  style={{ 
                    padding: "7px", 
                    borderRadius: "5px", 
                    border: "1px solid #d9d9d9", 
                    width: "100%", 
                    marginBottom: "15px", 
                    cursor: "default",
                    backgroundColor: "#f9f9f9"
                  }}
                  readOnly
                />
              </div>

              <input
                className="mt-3"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn btn-success"
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                    backgroundColor: "#93385D"
                  }}
                  type="submit"
                >
                  {"Submit"}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Add Fetch Data Slider Section */}
        {sliderType === 2 && (
          <div style={{ padding: "10px" }}>
            <div className="mb-3">
              <label style={{ fontSize: "13px", fontWeight: "400" }}>Date:</label>
              <input
                readOnly
                value={currentDate}
                style={{
                  padding: "7px",
                  borderRadius: "5px",
                  border: "1px solid #d9d9d9",
                  width: "100%",
                  backgroundColor: "#f9f9f9",
                }}
              />
            </div>

            {renderStatus()}

            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button
                className="btn btn-success"
                style={{
                  color: "#fff",
                  fontSize: "0.8rem",
                  backgroundColor: "#93385D"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleFetchData();
                }}
              >
                Fetch Data
              </button>
            </div>
          </div>
        )}
      </div>

      {confirmPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Data already exists</h3>
            <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
              Data for <b>{currentDate}</b> and <b>{selectedDs.label}</b> already exists.
              Do you want to Re Upload the data ?
            </p>
            <div className="popup-actions">
              <button
                onClick={() => {
                  setConfirmPopup(false);
                  handleDataUpload("re_upload");
                }}
                className="yes-btn"
              >
                Yes
              </button>
              <button
                onClick={() => setConfirmPopup(false)}
                className="no-btn"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </div>
  );
};

// Add status styles
const statusStyles = {
  loading: {
    border: "1px solid orange",
    backgroundColor: "#fff4e5",
    color: "orange",
    padding: "12px",
    borderRadius: "8px",
    marginTop: "12px",
    fontSize: "14px",
    lineHeight: "20px",
  },
  warning: {
    border: "1px solid orange",
    backgroundColor: "#fff4e5",
    color: "orange",
    padding: "12px",
    borderRadius: "8px",
    marginTop: "12px",
    fontSize: "14px",
    lineHeight: "20px",
  },
  success: {
    border: "1px solid green",
    backgroundColor: "#e6ffed",
    color: "green",
    padding: "12px",
    borderRadius: "8px",
    marginTop: "12px",
    fontSize: "14px",
    lineHeight: "20px",
  },
  error: {
    border: "1px solid red",
    backgroundColor: "#fdd",
    color: "red",
    padding: "12px",
    borderRadius: "8px",
    marginTop: "12px",
    fontSize: "14px",
    lineHeight: "20px",
  }
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: "12px"
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? 'normal' : 'normal',
  })
}

export default WarehousesTab;